import React, { ReactElement } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button from 'tbk-components/src/components/Button';
import { useRandomID } from '../../utils';

export interface IAccordionItem {
	/**
	 * @noUI
	 */
	accordionId?: string;
	index?: number;
	title?: string;
	expanded?: boolean;
	/**
	 * @control richtext
	 */
	content?: string;
}
export interface IAccordionProps extends IBaseElementProps {
	/**
	 * @noUI
	 */
	id?: string;
	accordionItems?: IAccordionItem[];
}

/**
 * Accordion
 * @icon excerpt-views
 * @block
 * @requiresHooks
 */

const Accordion: React.FC<IAccordionProps> = ({ accordionItems = [] }) => {
	const accordionID = useRandomID('accordion-key');

	if (!accordionItems) {
		return null;
	}

	return (
		<div className="accordion-container">
			<div
				id={accordionID}
				className={cn('accordion', 'accordion-flush')}
			>
				{accordionItems.length > 0 &&
					accordionItems.map((accordion, index) => (
						<div className="accordion-item">
							<div
								className="accordion-header"
								id={`${accordionID}--header-${index}`}
							>
								<Button
									className={cn(
										'accordion-button',
										!accordion.expanded && 'collapsed',
									)}
									data-bs-toggle="collapse"
									data-bs-target={`#${accordionID}--collapse-${index}`}
									aria-expanded={accordion.expanded}
									aria-controls={`${accordionID}--collapse-${index}`}
								>
									<h3>{accordion.title}</h3>
								</Button>
							</div>
							<div
								id={`${accordionID}--collapse-${index}`}
								className={cn(
									'accordion-collapse',
									'collapse',
									accordion.expanded ? 'show' : '',
								)}
								aria-labelledby={`accordion-header-${index}`}
								data-bs-parent={`#${accordionID}`}
							>
								<div className="accordion-body" dangerouslySetInnerHTML={{ __html: accordion.content }} />
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default Accordion;
